import { render, staticRenderFns } from "./MyDistributorSetting.vue?vue&type=template&id=3308f6b2"
import script from "./MyDistributorSetting.vue?vue&type=script&lang=js"
export * from "./MyDistributorSetting.vue?vue&type=script&lang=js"
import style0 from "./MyDistributorSetting.vue?vue&type=style&index=0&id=3308f6b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports